import { render, staticRenderFns } from "./MarketplaceFields.vue?vue&type=template&id=3837f728&scoped=true&"
import script from "./MarketplaceFields.vue?vue&type=script&lang=js&"
export * from "./MarketplaceFields.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceFields.vue?vue&type=style&index=0&id=3837f728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837f728",
  null
  
)

export default component.exports